import { render, staticRenderFns } from "./NoshiForm.vue?vue&type=template&id=db6f2d66&scoped=true&"
import script from "./NoshiForm.vue?vue&type=script&lang=ts&"
export * from "./NoshiForm.vue?vue&type=script&lang=ts&"
import style0 from "./NoshiForm.vue?vue&type=style&index=0&id=db6f2d66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db6f2d66",
  null
  
)

export default component.exports